import { type Option } from '@/src/utils';
import type { QuestionMetaDTO, BaseQtiQuestionDTO } from '@/src/lib';

export interface ChoiceDTO {
    id: number;
    text: string;
    text_es: string;
}

// META fields //
export interface StandardOption {
    id: number;
    name: string;
    gradeLevelMasterId: number;
}

export interface QuestionMetaOptionsDTO {
    difficultyLevelMasterOptions: Option[];
    primaryClaimMasterOptions: Option[];
    primaryTargetMasterOptions: Option[];
    depthOfKnowledgeMasterOptions: Option[];
    gradeLevelMasterOptions: Option[];
    standardOptions: StandardOption[];
}

export const defaultMeta: QuestionMetaDTO = {
    questionTypeMasterId: 0,
    keypadSetting: [],
    gradeLevelMasterIds: [],
    standards: [],
    difficultyLevelMasterId: 4,
    primaryClaimMasterId: 5,
    primaryTargetMasterId: 17,
    depthOfKnowledgeMasterId: 5,
    isPracticeQuestion: false,
    isHandScored: false,
    shouldShuffleOptions: false,
    shouldShowKeypad: false,
    isSpanishAllowed: false,
    isDynamicQuestion: false,
    score: 1,
};

// 7 - Stimulus //
export interface QtiStimulusQuestionForEditorDTO extends BaseQtiQuestionDTO {
    selectedQuestions: StimulusReferenceQuestionDTO[];
}
export interface StimulusReferenceQuestionStandardDTO {
    id: number;
    standardId: number;
    standardName: string;
}
export interface StimulusReferenceQuestionDTO {
    id: number;
    uuid: string;
    title: string;
    questionTypeMasterId: number;
    questionTypeMaster: string;
    questionStandards: StimulusReferenceQuestionStandardDTO[];
}
